import { EM_DASH } from "routes/custom_tables/grid/cellHelpers";
import { choiceColor } from "routes/custom_tables/choiceHelpers";
import ChoiceChip from "routes/custom_tables/grid/cells/ChoiceChip";

export default function MultiSelectCell({ value, column }) {
  const isEmpty = !Array.isArray(value) || value.length === 0;

  return isEmpty ? (
    <span className="tw:text-muted-foreground">{EM_DASH}</span>
  ) : (
    <div className="tw:flex tw:items-center tw:gap-1 tw:overflow-x-hidden tw:[scrollbar-width:thin] tw:[scrollbar-color:var(--color-text-muted)_var(--color-surface)] tw:hover:overflow-x-auto tw:focus-within:overflow-x-auto tw:[&::-webkit-scrollbar]:h-1 tw:[&::-webkit-scrollbar-track]:bg-card tw:[&::-webkit-scrollbar-thumb]:bg-muted-foreground tw:[&::-webkit-scrollbar-thumb]:rounded-full">
      {value.map((v, i) => (
        <ChoiceChip
          key={`${i}-${v}`}
          label={v}
          color={choiceColor(column?.options, v)}
        />
      ))}
    </div>
  );
}
